import { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import type { Observable } from 'rxjs';
import {
  STATUS_COLOR,
  STATUS_ICON,
} from '@features/csv-import/candidate-status-display';
import type { DraftPreviewPayload } from '../models/map-observables.models';
import type { Point2D } from '@shared/models/geometry.model';

const useStyles = makeStyles()(() => ({
  warning: {
    position: 'absolute',
    zIndex: 3,
    display: 'inline-flex',
    color: STATUS_COLOR.incomplete,
    lineHeight: 0,
    pointerEvents: 'none',
    transform: 'translate(-50%, -50%)',
  },
}));

type TemplatePlacementWarningProps = {
  preview$?: Observable<DraftPreviewPayload | undefined>;
};

/** Import-tab warning glyph centered on the preset while a preset cannot be placed. */
export const TemplatePlacementWarning = ({
  preview$,
}: TemplatePlacementWarningProps) => {
  const { classes } = useStyles();
  const [position, setPosition] = useState<Point2D>();
  useEffect(() => {
    setPosition(undefined);
    const subscription = preview$?.subscribe((preview) => {
      setPosition(
        preview?.templatePlacementInvalid
          ? preview.templateCenterScreenPoint
          : undefined,
      );
    });
    return () => subscription?.unsubscribe();
  }, [preview$]);
  if (!position) return null;
  return (
    <span
      role="img"
      aria-label="Cannot place footprint here"
      className={classes.warning}
      style={{ left: position[0], top: position[1] }}
    >
      {STATUS_ICON.incomplete}
    </span>
  );
};
